module.exports = __webpack_public_path__ + "img/play_1@2x.3fe661f6.png";